




















import { Component, Vue } from "vue-property-decorator";
import { activatePlayer } from "@/services/players/playerService";
import { ValidationModel, ValidationType } from "@/services/validation/types";
import { validateForm } from "@/services/validation/validationService";
import validate from "@/directives/validate";
import i18n from "@/i18n";
import { PlayerActivationDto, PlayerActivationStatus } from "@/services/players/types";

@Component({
    directives: { validate }
})
export default class PlayerActivationModal extends Vue {
    playerActivationId = "";
    validators = {
        id: {
            rules: [
                { type: ValidationType.Required },
                { type: ValidationType.Min, value: 5 }
            ]
        } as ValidationModel
    };

    errorMessage = "";
    async activatePlayer() {
        if (!await validateForm([this.validators])) {
            return;
        }

        activatePlayer(this.playerActivationId).then(response => {
            this.handleActivationResponse(response);
        }).catch(() => {
            this.errorMessage = i18n.t("player.activationFailed").toString();
        });
    }

    handleActivationResponse(response: PlayerActivationDto) {
        switch (response.status) {
        case PlayerActivationStatus.activated:
            this.$router.push({ name: "activatePlayer", params: { playerId: response.playerId } });
            this.$bvModal.hide("modal-playerActivation");
            return;
        case PlayerActivationStatus.notFound:
            this.errorMessage = i18n.t("player.playerDoesNotExist").toString();
            return;
        case PlayerActivationStatus.alreadyActivated:
            this.errorMessage = i18n.t("player.playerAlreadyActivated").toString();
            return;
        default:
            this.errorMessage = i18n.t("player.activationFailed").toString();
        }
    }

    resetState() {
        this.playerActivationId = "";
        this.errorMessage = "";
        this.validators = {
            id: {
                rules: [
                    { type: ValidationType.Required },
                    { type: ValidationType.Min, value: 5 }
                ]
            } as ValidationModel
        };
    }
}
